export interface IDimensions {
  departmentId: number;
  bearerId: number;
  purposeId: number;
}
